export default "__VITE_PUBLIC_ASSET__dc5c6d71__"